'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'diamond';
var width = 576;
var height = 512;
var aliases = [9830];
var unicode = 'f219';
var svgPathData = 'M49.9 289.9L16 256 49.9 222.1 254.1 17.9 288-16 321.9 17.9 526.1 222.1 560 256 526.1 289.9 321.9 494.1 288 528 254.1 494.1 49.9 289.9zM83.9 256L288 460.1 492.1 256 288 51.9 83.9 256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamond = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;